import { Component } from '@angular/core';
import { ThemeService } from '../../../services/theme.service';
import { ThemeType } from '../../../models/theme.models';

@Component({
  selector: 'ui-theme-toggle',
  template: `
    <button (click)="toggleTheme()">
      Switch to {{ nextTheme }} mode
    </button>
  `
})
export class ThemeToggleComponent {
  nextTheme: ThemeType = ThemeType.Dark;

  constructor(private themeService: ThemeService) {
    this.updateNextTheme();
  }

  toggleTheme(): void {
    this.themeService.toggleTheme();
    this.updateNextTheme();
  }

  private updateNextTheme(): void {
    this.nextTheme = this.themeService.getTheme() === ThemeType.Light ? ThemeType.Dark : ThemeType.Light;
  }
}
